import { IReducerAction } from 'src/interfaces/redux';
export * from './ui.selectors';

export interface IUIState {
  settingsVisible: boolean;
  fullscreen: boolean;
  isPictureInPictureEnabled: boolean;
  isUserActive: boolean;
  isMouseOnPlayer: boolean;
  subtitleSettingsVisible: boolean;
  isStatsVisible: boolean;
}

export const uiInitialState: IUIState = {
  settingsVisible: false,
  fullscreen: false,
  isPictureInPictureEnabled: false,
  isUserActive: true,
  isMouseOnPlayer: true,
  subtitleSettingsVisible: false,
  isStatsVisible: false,
};

export enum UIActionTypes {
  SHOW_SETTINGS = 'UI/SHOW_SETTINGS',
  HIDE_SETTINGS = 'UI/HIDE_SETTINGS',

  SET_FULLSCREEN = 'UI/SET_FULLSCREEN',
  EXIT_FULLSCREEN = 'UI/EXIT_FULLSCREEN',

  SET_PICTURE_IN_PICTURE = 'UI/SET_PICTURE_IN_PICTURE',
  EXIT_PICTURE_IN_PICTURE = 'UI/EXIT_PICTURE_IN_PICTURE',

  SET_USER_ACTIVE = 'UI/SET_USER_ACTIVE',
  UNSET_USER_ACTIVE = 'UI/UNSET_USER_ACTIVE',

  SET_MOUSE_ON_PLAYER = 'UI/SET_MOUSE_ON_PLAYER',
  UNSET_MOUSE_ON_PLAYER = 'UI/UNSET_MOUSE_ON_PLAYER',

  SHOW_SUBTITLE_SETTINGS = 'UI/SHOW_SUBTITLE_SETTINGS',
  HIDE_SUBTITLE_SETTINGS = 'UI/HIDE_SUBTITLE_SETTINGS',

  SHOW_STATS = 'UI/SHOW_STATS',
  HIDE_STATS = 'UI/HIDE_STATS',
}

export type IUIAction = IReducerAction<UIActionTypes>;

export default function uiReducer(state: IUIState = uiInitialState, action: IUIAction) {
  switch (action.type) {
    case UIActionTypes.SHOW_SETTINGS:
      return { ...state, settingsVisible: true };
    case UIActionTypes.HIDE_SETTINGS:
      return { ...state, settingsVisible: false };
    case UIActionTypes.SET_FULLSCREEN:
      return { ...state, fullscreen: true };
    case UIActionTypes.EXIT_FULLSCREEN:
      return { ...state, fullscreen: false };
    case UIActionTypes.SET_PICTURE_IN_PICTURE:
      return { ...state, isPictureInPictureEnabled: true };
    case UIActionTypes.EXIT_PICTURE_IN_PICTURE:
      return { ...state, isPictureInPictureEnabled: false };
    case UIActionTypes.SET_USER_ACTIVE:
      return { ...state, isUserActive: true };
    case UIActionTypes.UNSET_USER_ACTIVE:
      return { ...state, isUserActive: false };
    case UIActionTypes.SET_MOUSE_ON_PLAYER:
      return { ...state, isMouseOnPlayer: true };
    case UIActionTypes.UNSET_MOUSE_ON_PLAYER:
      return { ...state, isMouseOnPlayer: false };
    case UIActionTypes.SHOW_SUBTITLE_SETTINGS:
      return { ...state, subtitleSettingsVisible: true };
    case UIActionTypes.HIDE_SUBTITLE_SETTINGS:
      return { ...state, subtitleSettingsVisible: false };
    case UIActionTypes.SHOW_STATS:
      return { ...state, isStatsVisible: true };
    case UIActionTypes.HIDE_STATS:
      return { ...state, isStatsVisible: false };

    default:
      return state;
  }
}
